import React, { useContext, useEffect, useState } from "react";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// components
import StoreHeader from "./StoreHeader";
import Banner from "./Banner";

// hooks
import useObserver from "bodycodi/cmap/app/components/common/useObserver";

// utils
import { api } from "../../js/api";

const Store = () => {
  const { dispatch } = useContext(DispatchContext);
  const [list, setList] = useState<Array<object>>([]);
  const [scrollEnd, setScrollEnd] = useState<boolean>(true);
  const [pagination, setPagination] = useState<any>({
    page: 1,
    pageSize: 10,
  });
  const [_, setRef] = useObserver(async (entry: any, observer: any) => {
    observer.unobserve(entry.target);
    setScrollEnd(true);
    await fetchStoreBanners();
    observer.observe(entry.target);
  }, {});

  const fetchStoreBanners = async () => {
    await api
      .post("/bshop/banners", {
        criteria: {
          page: pagination.page,
          pageSize: pagination.pageSize,
        },
      })
      .then(({ data }) => {
        if (data.first) setList(data.results);
        else setList((prev) => prev.concat(data.results));

        if (data.last) {
          setScrollEnd(true);
          setPagination({ ...pagination, page: 1 });
        } else {
          setScrollEnd(false);
          setPagination({ ...pagination, page: pagination.page + 1 });
        }
      });
  };

  useEffect(() => {
    fetchStoreBanners();
  }, []);

  return (
    <div className="store-page">
      <StoreHeader />
      <div className="container">
        {list?.map((banner, index) => {
          return <Banner key={index} details={banner} />;
        })}
        {!scrollEnd && <div ref={setRef} />}
      </div>
    </div>
  );
};

export default Store;
